import { render, staticRenderFns } from "./AlertsBusiness.vue?vue&type=template&id=a14061f4&scoped=true&"
import script from "./AlertsBusiness.vue?vue&type=script&lang=ts&"
export * from "./AlertsBusiness.vue?vue&type=script&lang=ts&"
import style0 from "./AlertsBusiness.vue?vue&type=style&index=0&id=a14061f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14061f4",
  null
  
)

export default component.exports